import { CloudUpload } from "@mui/icons-material";
import { Button, Tooltip  } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useState } from "react";

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const UploadButton = ({text, tip, handler, color, iconCmp, ...others}) => {

  return (
    <Tooltip title={tip}>
      <Button
        component="label"
        color={color}
        role={undefined}
        tabIndex={-1}
        startIcon={iconCmp ?? <CloudUpload />}
        {...others}
      >
        {text}
        <VisuallyHiddenInput
          type="file"
          onChange={handler}
        />
      </Button>
    </Tooltip>
  );  
};

export default UploadButton;